/**
 * Removes specified keys from an object.
 *
 * @param obj - The object from which keys will be removed.
 * @param keysToRemove - An array of strings representing the keys to be removed from the object.
 * @returns The modified object with the specified keys removed.
 */
export const removeKeysFromObject = (obj: Record<string, unknown>, keysToRemove: string[] | undefined) => {
    if (!keysToRemove?.length) return obj;

    keysToRemove.forEach((key) => {
        delete obj[key];
    });
    return obj;
};
